import { Box, Circle, Flex, Text, VStack } from "@chakra-ui/react";
import React from "react";

export const STEPS = [
  "UPLOAD",
  "ANALYZING",
  "MAPPING_REVIEW",
  "PROCESSING",
  "DONE",
];

const LABELS = {
  UPLOAD: "Upload",
  ANALYZING: "Analyzing",
  MAPPING_REVIEW: "Review",
  PROCESSING: "Import",
  DONE: "Done",
};

export default function StepperHeader({ step }) {
  const currentIdx = STEPS.indexOf(step);

  return (
    <Flex justify="center" align="center" mb={2} px={4}>
      {STEPS.map((s, i) => {
        const isDone = i < currentIdx;
        const isActive = i === currentIdx;

        return (
          <React.Fragment key={s}>
            <VStack spacing={2}>
              <Circle
                size="48px"
                bg={isDone || isActive ? "teal.500" : "gray.200"}
                color={isDone || isActive ? "white" : "gray.500"}
                fontSize="sm"
                fontWeight="bold"
                boxShadow={
                  isActive ? "0 0 0 4px rgba(20, 184, 166, 0.2)" : "none"
                }
              >
                {isDone ? "✓" : i + 1}
              </Circle>

              <Text
                fontSize="13px"
                fontWeight="600"
                color={isDone || isActive ? "teal.600" : "gray.400"}
                textAlign="center"
              >
                {LABELS[s]}
              </Text>
            </VStack>

            {i < STEPS.length - 1 && (
              <Box
                w="70px"
                h="2px"
                bg={i < currentIdx ? "teal.500" : "gray.200"}
                mx={2}
                mt="-20px"
              />
            )}
          </React.Fragment>
        );
      })}
    </Flex>
  );
}
